import Vue from "vue";
import UiActionMenu from "@/components/ui/UiActionMenu.vue";
import UiBadge from "@/components/ui/UiBadge.vue";
import UiDocumentEditor from "@/components/ui/editor/UiDocumentEditor.vue";
import UiEmpty from "@/components/ui/UiEmpty.vue";
import UiFileDrop from "@/components/ui/UiFileDrop.vue";
import UiPageHeader from "@/components/ui/UiPageHeader.vue";
import UiPagination from "@/components/ui/UiPagination.vue";
import UiPills from "@/components/ui/UiPills.vue";
import UiRowActions from "@/components/ui/UiRowActions.vue";
import UiSection from "@/components/ui/UiSection.vue";
import UiSheet from "@/components/ui/UiSheet.vue";
import UiTableCard from "@/components/ui/UiTableCard.vue";

// Componentes do padrao visual, disponiveis em todas as telas sem import.
Vue.component("UiActionMenu", UiActionMenu);
Vue.component("UiBadge", UiBadge);
Vue.component("UiDocumentEditor", UiDocumentEditor);
Vue.component("UiEmpty", UiEmpty);
Vue.component("UiFileDrop", UiFileDrop);
Vue.component("UiPageHeader", UiPageHeader);
Vue.component("UiPagination", UiPagination);
Vue.component("UiPills", UiPills);
Vue.component("UiRowActions", UiRowActions);
Vue.component("UiSection", UiSection);
Vue.component("UiSheet", UiSheet);
Vue.component("UiTableCard", UiTableCard);
